import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { UserRoles } from '@app/first-contact/first-contact.component';
import { ChangableComponent } from '@models/changable.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { faq } from './first-contact-faq.variables';

@Component({
  selector: 'app-first-contact-faq',
  templateUrl: './first-contact-faq.component.html',
  styleUrls: ['./first-contact-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirstContactFaqComponent extends ChangableComponent {
  deviceService = inject(DeviceDetectorService);

  @Input() selectedRole: UserRoles;
  public faq = faq;
  public selectedFaqItem = null;

  public faqList() {
    return this.faq[this.selectedRole];
  }

  public onSelect(index: number) {
    this.selectedFaqItem = index;
    this.markForCheck();
  }

  public trackByFn(index) {
    return index;
  }
}
